import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { getDate } from "utils/formatDate";
import configs from "constants/configs";
import { Cookies } from "react-cookie";
import danhSachThongTinVayApi from "../../service/ChoThongTin/danhSachThongTinVayApi";
import moment from "moment";
import thongBaoThongTinVayApi from "service/ChoThongTin/thongBaoThongTinVayApi";
import thongBaoApi from "service/thongBaoApi";
import { ModalThongBaoKhiDangNhap } from "components/ThongBaoKhiDangNhap";
import { ModalThongBaoDangKyVayMoi } from "components/ThongBaoDangKyVayMoi";
import { ModalThongbaoHanSuDung } from "components/ThongBaoKhiDangNhap/ThongBaoHanSuDung";
import { ModalThongBaoApp } from "components/ThongBaoApp";
import userApi from "../../service/userApi";
import { TabThongBao } from "./TabThongBao";

// import { useCacheBuster } from 'react-cache-buster';
const HeaderV2 = (props) => {
  const cookies = new Cookies();
  let { list, onChange, thongTin, userInfo, thongBao } = props;
  let { Name, ExpiredDate, Code } = thongTin ? thongTin : {};
  let { Image, FullName, UserName } = userInfo ? userInfo : {};
  let { List, Total } = thongBao ? thongBao : {};

  const [isShowModelThongBao, setModelThongBao] = useState(false);
  const [isRoleChoTinDung, setRoleChoTinDung] = useState(false);
  const [isDangKyChoTinDung, setDangKyChoTinDung] = useState(false);
  const [listDanhSSach, setListDanhSach] = useState([]);
  const [iCountDataNew, setCountDataNew] = useState(0);
  const [logoURL, setLogo] = useState("");
  const [valueHanSuDung, setValueHanSuDung] = useState(-1);
  const [showThongBaoHanSuDung, SetShowThongBaoHanSuDung] = useState(false);
  const [listThongBao, setlistThongBao] = useState([]);
  const [listThongBaoMorman, setlistThongBaoMorman] = useState([]);
  const hideThongBaoHanSuDung = () => {
    if (showThongBaoHanSuDung == true) {
      cookies.set("isShowThongBaoHanDung", "0", { path: "/" });
      SetShowThongBaoHanSuDung(false);
    }
  };
  //const { checkCacheStatus } = useCacheBuster();
  const toggleModal = () => {
    setModelThongBao(false);
  };
  const toggleModalData = () => {
    setCountDataNew(0);
  };
  const callApiDataNew = () => {
    const interval = setInterval(() => {
      var date = moment().add(-60, "seconds").format("MM/DD/YYYY HH:mm:ss");
      thongBaoThongTinVayApi
        .getSoLuongDataMoi(userInfo.CompanyID, date)
        .then((responseDetail) => {
          if (responseDetail.status === 200) {
            setCountDataNew(responseDetail.data);
          }
        });
    }, 60000);
    return () => clearInterval(interval);
  };
  let urlChoTinDung = window.urlChoTinDung + "cho-thong-tin/danh-sach-vay.aspx";
  let urlDangKyCho =
    window.urlChoTinDung + "cho-thong-tin/Dang-Ky-Tai-Khoan.aspx";
  let urlError = "/trang-chu/Page-Error.aspx";
  const init = {
    iTotal: 0,
    List: [],
  };

  useEffect(() => {
    getLogo();

    //checkCacheStatus();
    if (typeof userInfo.CompanyID !== "undefined") {
      var popMsg = cookies.get("isShowThongBaoChoTD");
      if (typeof popMsg === "undefined" || popMsg != "1") {
        thongBaoThongTinVayApi
          .checkQuyenHienThi(userInfo.CompanyID)
          .then((responseDetail) => {
            if (responseDetail.data == "1") {
              setDangKyChoTinDung(true);
              setModelThongBao(false);
              cookies.set("isShowThongBaoChoTD", "0", { path: "/" });
            } else if (responseDetail.data == "0") {
              setModelThongBao(true);
              cookies.set("isShowThongBaoChoTD", "1", { path: "/" });
            }
          });
      } else {
        thongBaoThongTinVayApi
          .checkQuyenHienThi(userInfo.CompanyID)
          .then((responseDetail) => {
            if (responseDetail.data == "1") {
              setDangKyChoTinDung(true);
            }
          });
      }
      danhSachThongTinVayApi.checkRoleChoTinDung().then((res) => {
        if (
          typeof res.data.IsRoleChoTinDung === "undefined" ||
          res.data.IsRoleChoTinDung == true
        ) {
          setRoleChoTinDung(true);
          let userMorman =
            userInfo.CompanyID +
            "&" +
            userInfo.CompanyName +
            "&" +
            userInfo.NameDaiDien +
            "&" +
            userInfo.Administrator;
          const token = cookies.get("userInfo").replace(/"/g, "");
          cookies.set("tokenMorman", token, {
            domain: ".morman.vn",
            path: "/",
          });
          cookies.set("userMorman", userMorman, {
            domain: ".morman.vn",
            path: "/",
          });
        } else {
          cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
          cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
        }
      });

      /// lấy count hiển thị ở chuông thông báo, và danh sách khi click vào
      const dataSearch = {
        IdCuaHang: userInfo.CompanyID,
        sHoVaTen: "",
        iPageIndex: 1,
        LoaiDangKy: "",
        iPageSize: 20,
      };
      thongBaoThongTinVayApi.danhSachDangKyVay(dataSearch).then((response) => {
        if (response != null && response.data != null) {
          setListDanhSach({
            ...listDanhSSach,
            iTotal: response.data.iTotal,
            List: response.data.List,
          });
          callApiDataNew();
        }
      });
    } else {
      cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
      cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
    }
    CheckSuDung();
    CheckHanSuDung();
    ThongBaoDuyetIp();
    ThongBaoMorman();
  }, [userInfo.CompanyID]);

  const [isThongBaoApp, setIsThongBaoApp] = useState(false);
  const [nameThongBaoApp, setNameThongBaoApp] = useState("");

  const CheckSuDung = () => {
    setIsThongBaoApp(false);
    setNameThongBaoApp("");

    var noshowapp = cookies.get("noshowapp");
    if (noshowapp === "" || noshowapp === undefined || noshowapp === null) {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        setIsThongBaoApp(true);
        setNameThongBaoApp("Android");
      }
      if (/android/i.test(userAgent)) {
        setIsThongBaoApp(true);
        setNameThongBaoApp("Android");
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        setIsThongBaoApp(true);
        setNameThongBaoApp("iOS");
      }
    }
  };

  const CheckHanSuDung = () => {
    if (UserName != undefined) {
      userApi.checkhansudung(UserName).then((response) => {
        if (
          response.data.IsHetHan != null &&
          response.data.IsHetHan != undefined
        ) {
          if (response.data.IsHetHan == true) {
            console.log("Logout");
            cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
            cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
            window.location.href = configs.mormanServer + "dang-nhap.aspx";
          } else if (response.data.Logout == true) {
            cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
            cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
            window.location.href = configs.mormanServer + "dang-nhap.aspx";
          } else {
            setValueHanSuDung(response.data.iSoNgayConLai);
            var isShowThongBaoHanDung = cookies.get("isShowThongBaoHanDung");
            if (isShowThongBaoHanDung != "0") {
              if (
                response.data.iSoNgayConLai &&
                response.data.iSoNgayConLai <= 5 &&
                response.data.iSoNgayConLai > -1
              ) {
                SetShowThongBaoHanSuDung(true);
              }
            }
          }
        }
      });
    }
  };

  const [IsSuDungIpBaoMat, SetIsSuDungIpBaoMat] = useState(false);
  const [TongXacThuc, SetTongXacThuc] = useState(0);
  const [DanhSachThongBao, SetDanhSachThongBao] = useState([]);
  const ThongBaoDuyetIp = () => {
    thongBaoApi.listThongBaoIp().then((response) => {
      if (response.data && response.data.IsSuDungIpBaoMat != undefined) {
        let isBaoMat = response.data.IsSuDungIpBaoMat;
        if (isBaoMat === true) {
          SetTongXacThuc(response.data.TongXacThuc);
          SetDanhSachThongBao(response.data.DanhSachThongBao);
        }
        SetIsSuDungIpBaoMat(isBaoMat);
      }
    });
  };
  const ThongBaoMorman = () => {
    if (UserName != undefined) {
      thongBaoApi
        .listThongBaoMornan({
          username: UserName,
          pageIndex: 1,
          pageSize: 20,
        })
        .then((response) => {
          if (response.data) {
            setlistThongBaoMorman(response.data.List);
          }
        });
    }
  };
  // So thong bao moi o lan kiem tra gan nhat, de biet khi nao can tai lai danh sach
  const soThongBaoMoiRef = useRef(null);

  // Dinh ky hoi server xem co thong bao moi khong. Chi goi API dem (nhe),
  // chi tai lai ca danh sach khi con so thay doi.
  useEffect(() => {
    if (typeof UserName === "undefined" || UserName === null) return;

    const kiemTraThongBaoMoi = () => {
      thongBaoApi
        .soLuongThongBaoMoi({ username: UserName })
        .then((response) => {
          if (!response || !response.ok || !response.data) return;

          const soMoi = Number(response.data.SoLuongThongBaoMoi) || 0;

          if (
            soThongBaoMoiRef.current !== null &&
            soThongBaoMoiRef.current !== soMoi
          ) {
            ThongBaoMorman();
          }
          soThongBaoMoiRef.current = soMoi;
        });
    };

    kiemTraThongBaoMoi();
    const timer = setInterval(kiemTraThongBaoMoi, 60000);
    return () => clearInterval(timer);
  }, [UserName]);

  // Danh dau 1 thong bao da doc. Cap nhat state tai cho thay vi load lai
  // ca danh sach, vi ThongBaoMorman() chi chay theo [userInfo.CompanyID].
  const danhDauDaDoc = (id) => {
    if (typeof UserName === "undefined" || !id) return;

    const daDoc = listThongBaoMorman.find(
      (x) => x.ID === id && Number(x.TrangThai) !== 0,
    );
    if (daDoc) return; // da doc roi thi khong goi API nua

    setlistThongBaoMorman((lst) =>
      lst.map((x) => (x.ID === id ? { ...x, TrangThai: 1 } : x)),
    );

    thongBaoApi
      .capNhatTrangThaiThongBao({ username: UserName, id, status: 1 })
      .then((response) => {
        // API loi thi tra lai trang thai chua doc
        if (
          !response ||
          !response.ok ||
          (response.data && response.data.Error === 1)
        ) {
          setlistThongBaoMorman((lst) =>
            lst.map((x) => (x.ID === id ? { ...x, TrangThai: 0 } : x)),
          );
        }
      });
  };

  // Danh dau tat ca thong bao Morman da doc
  const danhDauTatCaDaDoc = () => {
    if (typeof UserName === "undefined") return;

    const truocDo = listThongBaoMorman;
    setlistThongBaoMorman((lst) => lst.map((x) => ({ ...x, TrangThai: 1 })));

    thongBaoApi
      .capNhatTrangThaiTatCa({ username: UserName, status: 1 })
      .then((response) => {
        if (
          !response ||
          !response.ok ||
          (response.data && response.data.Error === 1)
        ) {
          setlistThongBaoMorman(truocDo);
        }
      });
  };

  // Số thông báo Morman chưa đọc, hiện trên icon chuông ở header
  const soThongBaoChuaDoc = (listThongBaoMorman || []).filter(
    (x) => Number(x.TrangThai) === 0,
  ).length;

  const LuuDiaChiIp = (code) => {
    thongBaoApi.LuuDiaChiIP(code).then((response) => {
      if (response.data) {
        ThongBaoDuyetIp();
      }
    });
  };

  const getLogo = () => {
    userApi.getLogoUrl().then((response) => {
      setLogo(response.data);
    });
  };

  const XoaThongBaoDuyetIp = (id) => {
    thongBaoApi.XoaThongBaoDuyetIP(id).then((response) => {
      if (response.data) {
        ThongBaoDuyetIp();
      }
    });
  };
  const LogOut = () => {
    cookies.set("getCurrentUser", "", { path: "/" });
    localStorage.setItem("getMenu", "0");
    cookies.set("isDungChinhThuc", "0", { domain: ".morman.vn", path: "/" });
    cookies.set("tokenMorman", "", { domain: ".morman.vn", path: "/" });
    cookies.set("userMorman", "", { domain: ".morman.vn", path: "/" });
    cookies.set("isShowThongBaoHanDung", "1", { path: "/" });
    localStorage.removeItem("check_ThongBao");
    window.location.href = configs.mormanServer + "dang-nhap.aspx?Logout=1";
  };

  return (
    <nav className="content header-navbar navbar-expand-md navbar navbar-with-menu navbar-without-dd-arrow fixed-top navbar-light  navbar-brand-center page-color1">
      <div className="navbar-wrapper">
        <div className="navbar-header">
          <ul className="nav navbar-nav flex-row">
            <li className="nav-item mobile-menu d-md-none mr-auto">
              <a
                className="nav-link nav-menu-main menu-toggle hidden-xs"
                href={window.mormanServer + "trang-chu.aspx"}
              >
                <i className="ft-menu font-large-1"></i>
              </a>
            </li>

            <li className="nav-item d-md-none">
              <a
                className="navbar-brand"
                href={window.mormanServer + "trang-chu.aspx"}
              >
                <h3 className="brand-text store">{Name}</h3>
              </a>
            </li>

            <li className="nav-item d-md-none">
              <a
                href={window.mormanServer + "trang-chu.aspx"}
                className="nav-link open-navbar-container"
                data-toggle="collapse"
                data-target="#navbar-mobile"
              >
                <i className="la la-ellipsis-v"></i>
              </a>
            </li>
          </ul>
        </div>

        <div className="navbar-container content">
          <div className="collapse navbar-collapse" id="navbar-mobile">
            <ul className="nav navbar-nav mr-auto float-left ">
              <li className="dropdown nav-item mega-dropdown width-dropdown home-newcv">
                <div className="content-header-right2">
                  <a
                    className="dropdown-toggle nav-link store store-mb"
                    href={"/"}
                    data-toggle="dropdown"
                  >
                    <span style={{ width: "100px" }}>{Name}</span>{" "}
                    <i
                      className="fa-solid fa-caret-down"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                  {list && (
                    <ul
                      className="mega-dropdown-menu dropdown-menu row"
                      style={{ borderRadius: "10px", left: "0px" }}
                    >
                      {list.map((item, index) => (
                        <li
                          className="col-md-3 sotre-list"
                          key={"cuaHang" + index}
                          style={{ paddingTop: 15 }}
                        >
                          <div class="row" style={{ paddingRight: "15px" }}>
                            <div
                              class="col-md-2  hidden-mobile-main"
                              style={{
                                textAlign: "right",
                                paddingRight: 0,
                                paddingTop: 6,
                              }}
                            >
                              {(item.isHanDung == false ||
                                item.Status === 2) && (
                                <i
                                  class="fa-solid fa-building-columns"
                                  style={{ color: "red" }}
                                ></i>
                              )}
                              {item.isHanDung == true && item.Status !== 2 && (
                                <i
                                  class="fa-solid fa-building-columns"
                                  style={{ color: "#00B69B" }}
                                ></i>
                              )}
                            </div>
                            <div class="col-md-10" style={{ paddingLeft: 0 }}>
                              {(item.isHanDung == false ||
                                item.Status === 2) && (
                                <>
                                  <a
                                    // style={{ cursor: "no-drop" }}
                                    onClick={onChange(item.Code)}
                                  >
                                    <div
                                      class="mega-menu-carousel-example"
                                      style={{
                                        borderRadius: "7px",
                                        backgroundColor: "#FFE2E2",
                                        paddingTop: "10px",
                                        fontSize: "16px",
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          textTransform: "uppercase",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {item.Name}{" "}
                                      </span>
                                      <i
                                        class="fa-solid fa-lock"
                                        style={{ color: "red", float: "right" }}
                                      ></i>
                                    </div>
                                    <div
                                      className="mega-menu-carousel-example"
                                      style={{ marginTop: 10 }}
                                    >
                                      <div>
                                        {/* <i class="fa-solid fa-location-dot" style={{paddingRight: "9px"}}></i> */}
                                        <img
                                          src="/images/icons/point.svg"
                                          style={{
                                            marginRight: "4px",
                                            width: "23px",
                                          }}
                                        ></img>{" "}
                                        {item.Address}
                                      </div>
                                    </div>
                                    <div className="mega-menu-carousel-example">
                                      <div>
                                        {" "}
                                        <i className="la la-phone-square"></i>{" "}
                                        {item.Phone}
                                      </div>
                                    </div>
                                  </a>
                                </>
                              )}

                              {item.Code == Code &&
                                item.Status !== 2 &&
                                item.isHanDung == true && (
                                  <>
                                    <a onClick={onChange(item.Code)}>
                                      <div
                                        class="mega-menu-carousel-example"
                                        style={{
                                          borderRadius: "7px",
                                          backgroundColor: "#00B69B",
                                          paddingTop: "10px",
                                          fontSize: "16px",
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            textTransform: "uppercase",
                                            fontWeight: "bold",
                                            color: "white",
                                          }}
                                        >
                                          {item.Name}{" "}
                                        </span>
                                      </div>
                                      <div
                                        className="mega-menu-carousel-example"
                                        style={{ marginTop: 10 }}
                                      >
                                        <div>
                                          {/* <i class="fa-solid fa-location-dot" style={{paddingRight: "9px"}}></i> */}
                                          <img
                                            src="/images/icons/point.svg"
                                            style={{
                                              marginRight: "4px",
                                              width: "23px",
                                            }}
                                          ></img>{" "}
                                          {item.Address}
                                        </div>
                                      </div>
                                      <div className="mega-menu-carousel-example">
                                        <div>
                                          {" "}
                                          <i className="la la-phone-square"></i>{" "}
                                          {item.Phone}
                                        </div>
                                      </div>
                                    </a>
                                  </>
                                )}

                              {item.Code != Code &&
                                item.Status !== 2 &&
                                item.isHanDung == true && (
                                  <>
                                    <a onClick={onChange(item.Code)}>
                                      <div
                                        class="mega-menu-carousel-example"
                                        style={{
                                          borderRadius: "7px",
                                          backgroundColor: "#EFF2F9",
                                          paddingTop: "10px",
                                          fontSize: "16px",
                                          paddingLeft: "10px",
                                        }}
                                      >
                                        <span
                                          style={{
                                            textTransform: "uppercase",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          {item.Name}{" "}
                                        </span>
                                      </div>
                                      <div
                                        className="mega-menu-carousel-example"
                                        style={{ marginTop: 10 }}
                                      >
                                        <div>
                                          <img
                                            src="/images/icons/point.svg"
                                            style={{
                                              marginRight: "4px",
                                              width: "23px",
                                            }}
                                          ></img>{" "}
                                          {item.Address}
                                        </div>
                                      </div>
                                      <div className="mega-menu-carousel-example">
                                        <div>
                                          {" "}
                                          <i className="la la-phone-square"></i>{" "}
                                          {item.Phone}
                                        </div>
                                      </div>
                                    </a>
                                  </>
                                )}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </li>
            </ul>
            <ul
              className="nav navbar-nav float-right  avatar-mb"
              style={{ position: "relative" }}
            >
              {valueHanSuDung < 15 && (
                <li className="dropdown dropdown-notification nav-item hidden-mobile-main notiVay">
                  <span
                    className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                    style={{ color: "red", marginRight: 10 }}
                  >
                    HSD( {valueHanSuDung} NGÀY)
                  </span>
                </li>
              )}
              <li
                className="dropdown dropdown-notification nav-item hidden-mobile-main"
                style={{ width: 100 }}
              >
                <a
                  href="http://timnoxau.morman.vn/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span
                    className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                    style={{ color: "black", fontSize: 14 }}
                  >
                    <img
                      src="/app-assets/images/TimNoXau.svg"
                      alt=""
                      style={{ width: 14, marginRight: 5, marginTop: -4 }}
                    />
                    Tìm nợ xấu
                  </span>
                </a>
              </li>
              <li
                class="dropdown dropdown-notification nav-item  hidden-mobile-main"
                style={{
                  borderLeftColor: "#BDC0CF",
                  borderLeftStyle: "solid",
                  borderLeftWidth: "1px",
                  height: 25,
                  marginTop: 9,
                }}
              ></li>
              <li
                className="dropdown dropdown-notification nav-item hidden-mobile-main"
                style={{ width: 30 }}
              >
                <a
                  className="nav-link nav-link-label"
                  href="https://www.facebook.com/groups/Hotro.MorMan/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ paddingTop: 3 }}
                >
                  <img src="/app-assets/images/icon-fb-v2-header.png" />
                </a>
              </li>
              <li className="dropdown dropdown-notification nav-item  hidden-mobile-maindrop-question">
                <a
                  className="nav-link nav-link-label"
                  href={"/ticket/danhsach.aspx"}
                  style={{ padding: "3px" }}
                >
                  <img src="/app-assets/images/icon-question-v2-header.png" />
                </a>
              </li>
              <li
                className="dropdown dropdown-notification nav-item hidden-mobile-main"
                style={{ width: 30 }}
              >
                <a
                  className="nav-link nav-link-label"
                  href={"/"}
                  data-toggle="dropdown"
                  style={{ paddingTop: 3 }}
                >
                  <img src="/app-assets/images/icon-phone-v2-header.png" />
                  {/* HSD: {getDate(ExpiredDate)} */}
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-media dropdown-menu-right"
                  style={{
                    width: "150px",
                    paddingLeft: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <li classNamess="w-150">
                    <span classNamess="text-transfer">
                      <b>Hotline</b>
                      <br />
                      <img
                        src="/app-assets/images/icon-dt-chi-tiet-cua-hang.png"
                        style={{ width: "18px", margin: 3, color: "black" }}
                      />{" "}
                      090 328 5356
                      <br />
                      <img
                        src="/app-assets/images/icon-dt-chi-tiet-cua-hang.png"
                        style={{ width: "18px", margin: 3, color: "black" }}
                      />{" "}
                      0981 528 850
                    </span>
                  </li>
                </ul>
              </li>
              <li
                className="dropdown dropdown-notification nav-item hidden-mobile-main"
                style={{ width: 30 }}
              >
                <a
                  className="nav-link nav-link-label"
                  href={"/"}
                  data-toggle="dropdown"
                  style={{ paddingTop: 3 }}
                >
                  <img src="/app-assets/images/icon-header-ho-tro.png" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-media dropdown-menu-right"
                  style={{
                    width: "400px",
                    paddingLeft: "10px",
                    borderRadius: "10px",
                  }}
                >
                  <li className="w-400">
                    <span classNames="text-transfer">
                      <b>Chuyển tiền qua tài khoản ngân hàng:</b>
                      <br />
                      <span
                        classNames="text-transfer-color"
                        style={{ color: "#086467", fontWeight: "bold" }}
                      >
                        1. Ngân hàng thương mại cổ phần Quân đội – Military
                        Commercial Joint Stock Bank – (MB):
                      </span>
                      <br />
                      Số tài khoản: 0771100034006
                      <br />
                      Chủ tài khoản: Công ty cổ phần công nghệ và truyền thông
                      Niềm Tin
                      <br />
                      Chi nhánh: Đống Đa
                      <br />
                      {/* <span
                        classNames="text-transfer-color"
                        style={{ color: "#086467", fontWeight: "bold" }}
                      >
                        2. Ngân hàng TMCP Kỹ thương Việt Nam – Vietnam
                        Technology and Commercial Joint Stock Bank – (TCB):
                      </span>
                      <br />
                      Số tài khoản: 19135813652017
                      <br />
                      Chủ tài khoản: Trần Anh Trung
                      <br />
                      <span
                        classNamess="text-transfer-color"
                        style={{ color: "#086467", fontWeight: "bold" }}
                      >
                        Ghi chú khi chuyển khoản:
                      </span> */}
                      <br />
                      Tại mục “Nội Dung” khi chuyển khoản, bạn ghi rõ: TK:
                      Ten_Dang_Nhap (Thay "Ten_Dang_Nhap" bằng tài khỏan đăng
                      nhập của bạn)
                    </span>
                  </li>
                </ul>
              </li>
              <li
                className="dropdown dropdown-notification nav-item hidden-mobile-main"
                style={{ width: 30 }}
              >
                <a
                  className="nav-link nav-link-label"
                  href={() => false}
                  data-toggle="dropdown"
                  style={{ paddingTop: 3 }}
                >
                  <img src="/app-assets/images/icon-notification-v2-header.png" />
                  {soThongBaoChuaDoc > 0 && (
                    <span
                      className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                      style={{
                        backgroundColor: "#ff4961",
                        width: soThongBaoChuaDoc > 99 ? "24px" : "17px",
                        height: "17px",
                        fontSize: "9px",
                        color: "white",
                      }}
                    >
                      {soThongBaoChuaDoc > 99 ? "99+" : soThongBaoChuaDoc}
                    </span>
                  )}
                </a>
                <ul
                  className="mega-dropdown-menu dropdown-menu row"
                  style={{
                    borderRadius: "10px",
                    width: "400px",
                    left: "-200px",
                  }}
                >
                  <li
                    class="scrollable-container media-list w-100 ps-container ps-theme-dark"
                    style={{
                      // .media-list trong bootstrap-extended.min.css chặn max-height 18.2rem,
                      // inline style để đè lên cho panel cao bằng 50% chiều cao màn hình
                      maxHeight: "50vh",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    <TabThongBao
                      lstThongBaoMorman={listThongBaoMorman}
                      lstThongBaoHeThong={List}
                      lstChoTinDung={listDanhSSach}
                      isRoleChoTinDung={isRoleChoTinDung}
                      urlChoTinDung={urlChoTinDung}
                      urlError={urlError}
                      onDanhDauDaDoc={danhDauDaDoc}
                      onDanhDauTatCaDaDoc={danhDauTatCaDaDoc}
                    />

                    <div class="ps-scrollbar-x-rail">
                      <div class="ps-scrollbar-x" tabindex="0"></div>
                    </div>
                    <div class="ps-scrollbar-y-rail">
                      <div class="ps-scrollbar-y" tabindex="0"></div>
                    </div>
                  </li>
                </ul>
              </li>
              {IsSuDungIpBaoMat === true && (
                <>
                  <li className="dropdown dropdown-notification nav-item hidden-mobile-main">
                    <a
                      className="nav-link nav-link-label"
                      href={() => false}
                      data-toggle="dropdown"
                      style={{ paddingTop: 3 }}
                    >
                      <img src="/app-assets/images/icon-question-v2-header.png" />
                      <span
                        className="badge badge-pill badge-default badge-danger badge-default badge-up badge-glow"
                        style={{
                          width: "17px",
                          height: "17px",
                          fontSize: "8px",
                        }}
                      >
                        {TongXacThuc}
                      </span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-media dropdown-menu-right hidden-mobile-main">
                      <li class="scrollable-container media-list w-120 ps-container ps-theme-dark">
                        {DanhSachThongBao &&
                          DanhSachThongBao.map((item) => {
                            let { ID, UserName, Code, IP } = item;
                            return (
                              <div
                                className="media"
                                style={{ padding: "12px" }}
                              >
                                <div className="media-body">
                                  <table style={{ clear: "both" }}>
                                    <tr>
                                      <td>
                                        <p className="notification-text">
                                          Mã xác thực đăng nhập của tài khoản{" "}
                                          <b>{UserName}</b> với địa chỉ IP {IP}{" "}
                                          :{" "}
                                          <b
                                            style={{
                                              color: "#c0392b",
                                              fontSize: "16px",
                                            }}
                                          >
                                            {Code}
                                          </b>
                                        </p>
                                      </td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            if (
                                              window.confirm(
                                                "Bạn muốn lưu địa chỉ IP?",
                                              )
                                            ) {
                                              LuuDiaChiIp(Code);
                                            }
                                          }}
                                        >
                                          <i className="fas fa-save"></i>
                                        </a>
                                      </td>
                                      <td>
                                        <a
                                          onClick={() => {
                                            if (
                                              window.confirm(
                                                "Bạn muốn xóa mã xác thực đã chọn?",
                                              )
                                            ) {
                                              XoaThongBaoDuyetIp(ID);
                                            }
                                          }}
                                        >
                                          <i className="fas fa-trash"></i>
                                        </a>
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            );
                          })}

                        <div class="ps-scrollbar-x-rail">
                          <div class="ps-scrollbar-x" tabindex="0"></div>
                        </div>
                        <div class="ps-scrollbar-y-rail">
                          <div class="ps-scrollbar-y" tabindex="0"></div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </>
              )}

              <li
                class="dropdown dropdown-notification nav-item hidden-mobile-main"
                style={{ paddingTop: 7, fontWeight: "bold", color: "#fff" }}
              >
                <span class="nav-item mobile-menu mr-auto">{FullName}</span>
              </li>
              <li
                className="dropdown dropdown-user nav-item"
                style={{ marginLeft: 0 }}
              >
                <a
                  className="dropdown-toggle nav-link dropdown-user-link"
                  href={"/"}
                  data-toggle="dropdown"
                >
                  <span
                    className="avatar avatar-online"
                    style={{ backgroundColor: "#ddeaeb" }}
                  >
                    <img
                      src={
                        Image
                          ? Image
                          : "/app-assets/images/portrait/small/avatar-s-19.png"
                      }
                      alt="avatar"
                    />
                  </span>
                  <i
                    className="fa-solid fa-caret-down"
                    style={{ marginBottom: "10px", color: "#fff" }}
                  ></i>
                </a>
                <div
                  class="dropdown-menu dropdown-menu-right bradius drop-avatar-v2"
                  style={{
                    width: 300,
                    color: "black",
                    marginTop: "1rem",
                  }}
                >
                  <div class="row">
                    <div
                      class="col-4"
                      style={{
                        paddingTop: 11,
                        paddingLeft: 30,
                        paddingRight: 20,
                      }}
                    >
                      <span class="avatar avatar-online">
                        <img
                          src={
                            Image
                              ? Image
                              : "/app-assets/images/portrait/small/avatar-s-19.png"
                          }
                          alt="avatar"
                          style={{ width: 75, maxWidth: "300%" }}
                        />
                      </span>
                    </div>
                    <div class="col-8">
                      <span class="font-bold">{FullName}</span>
                      {UserName}

                      <a
                        class="btnChinhSuaThongTin"
                        href={"/trang-chu/thong-tin-dang-nhap.aspx"}
                        style={{ width: 170 }}
                      >
                        Chỉnh sửa thông tin
                      </a>
                    </div>
                  </div>
                  <div class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    href={"/trang-chu/thong-tin-dang-nhap.aspx#tab2"}
                  >
                    <img
                      src="/app-assets/images/DoiMatKhau.svg"
                      style={{ width: "18px", marginRight: "15px" }}
                    />
                    Thay đổi mật khẩu
                  </a>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      LogOut();
                    }}
                  >
                    <img
                      src="/app-assets/images/iconLogout.svg"
                      style={{ width: "18px", marginRight: "15px" }}
                    />{" "}
                    Đăng xuất
                  </a>
                  {/* <div class="dropdown-divider"></div>
                  <span class="font-bold dropdown-item">Hotline
                  </span>
                  <span class="dropdown-item"><i class="fa-solid fa-phone"></i>090 328 5359</span>
                  <span class="dropdown-item"><i class="fa-solid fa-phone"></i>(024) 6659 7982</span> */}
                  <span
                    class="dropdown-item text-center"
                    style={{ width: "100%" }}
                  >
                    <span
                      class="dropdown-item text-center"
                      style={{
                        backgroundColor: "#DDEAEB",
                        borderRadius: "1rem",
                      }}
                    >
                      {" "}
                      Hạn sử dụng:{getDate(ExpiredDate)}
                    </span>
                  </span>
                  <span class="dropdown-item text-center">
                    All rights reserved. Phiên bản 8.1
                  </span>
                </div>

                {/* cũccccccccccccccccccccccccccccccc */}
                {/* <div className="dropdown-menu dropdown-menu-right">
                  <a className="dropdown-item" href={"/"}>
                    <b>{FullName}</b>
                    <br />({UserName})
                  </a>
                  <a
                    className="dropdown-item"
                    href={
                      configs.mormanServer +
                      "trang-chu/thong-tin-dang-nhap.aspx"
                    }
                  >
                    <i className="ft-user"></i>
                    Thông tin đăng nhập
                  </a>
                  <a
                    className="dropdown-item"
                    href={configs.mormanServer + "trang-chu/doi-mat-khau.aspx"}
                  >
                    <i className="la la-key"></i>
                    Đổi mật khẩu
                  </a>

                  <div className="dropdown-divider"></div>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      LogOut();
                    }}
                  >
                    <i className="ft-power"></i>
                    Đăng xuất
                  </a>
                </div> */}
              </li>
            </ul>
          </div>
        </div>
      </div>
      {isShowModelThongBao && (
        <></>
        // <ModalThongBaoKhiDangNhap
        //   show={isShowModelThongBao}
        //   onHide={toggleModal}
        // />
      )}
      {iCountDataNew > 0 && (
        <ModalThongBaoDangKyVayMoi
          show={true}
          iCountDataNew={iCountDataNew}
          onHide={toggleModalData}
        />
      )}
      {showThongBaoHanSuDung && (
        <ModalThongbaoHanSuDung
          show={showThongBaoHanSuDung}
          hideThongBaoHanSuDung={hideThongBaoHanSuDung}
          value={valueHanSuDung}
        ></ModalThongbaoHanSuDung>
      )}

      {isThongBaoApp && (
        <ModalThongBaoApp
          show={isThongBaoApp}
          nameapp={nameThongBaoApp}
          setIsThongBaoApp={setIsThongBaoApp}
        ></ModalThongBaoApp>
      )}
    </nav>
  );
};

HeaderV2.propTypes = {
  showBackground: PropTypes.bool,
};

export default HeaderV2;
